import { useState } from 'react';
import styled from 'styled-components';
import { FloatingButton } from '~ui-kit';

const FloatingButtonMenu = ({ buttons }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!open);
  const { main, children } = buttons;

  return (
    <Container>
      <FloatingButton
        onClick={toggleOpen}
        title={main.title}
        icon={main.icon}
        faIcon={main.faIcon}
      />
      {children.toReversed().map(child => (
        <FloatingButton
          key={child.title}
          onClick={child.onClick}
          title={child.title}
          icon={child.icon}
          faIcon={child.faIcon}
          collapsed={!open}
        />
      ))}
    </Container>
  );
};

const Container = styled.div``;

export default FloatingButtonMenu;
